import { ApiHelper } from "@datanac/datanac-api-toolkit/dist/api-helper";
import { DOCUMENT_FORM_NAME_DEBT_SCHEDULE } from "@datanac/datanac-api-toolkit/dist/import/importHelpers";
import { v4 } from "uuid";

import { _sessionManager, UsersApiHelper } from "../../../api/ApiHelper";

export const OBJECT_NAME_DEBT_SCHEDULE = "debt_schedule";

// ---

export const CONTAINER_NAME_DEBT_SCHEDULE_HEADER = "header";

export const CONTAINER_NAME_DEBT_SCHEDULE_CROPS = "crops";
export const CONTAINER_NAME_DEBT_SCHEDULE_EQUIPMENT = "equipment";
export const CONTAINER_NAME_DEBT_SCHEDULE_LIVESTOCK = "livestock";
export const CONTAINER_NAME_DEBT_SCHEDULE_REAL_ESTATE = "real_estate";

// ---

export const ITEM_NAME_DEBT_SCHEDULE_AMOUNT = "amount";
export const ITEM_NAME_DEBT_SCHEDULE_INTEREST_PAID = "interest_paid";
export const ITEM_NAME_DEBT_SCHEDULE_PRINCIPAL_PAID = "principal_paid";
export const ITEM_NAME_DEBT_SCHEDULE_LIABILITY_CURRENT = "liability_current";
export const ITEM_NAME_DEBT_SCHEDULE_LIABILITY_NONCURRENT = "liability_noncurrent";
export const ITEM_NAME_DEBT_SCHEDULE_PRINCIPAL = "principal";
export const ITEM_NAME_DEBT_SCHEDULE_INTEREST_ACCRUED = "interest_accrued";

// ---

export const COLLATERAL_MARGIN_RATE_EQUIPMENT = 0.65;
export const COLLATERAL_MARGIN_RATE_REAL_ESTATE = 0.8;
export const COLLATERAL_MARGIN_RATE_LIVESTOCK = 0.65;
export const COLLATERAL_MARGIN_RATE_CROPS = 0.75;
export const COLLATERAL_MARGIN_RATE_ARC_PLC = 0.9;

// --- --- ---

// export const DOCUMENT_DICTIONARY_DEFAULT_VALUES_DEBT_SCHEDULE = [
// ]

export const UpdateDebtSchedule = async (debtSchedules, globalState) => {
  try {
    const _documentsFilter = {
      year: globalState.crop_year,
      document_type_name: DOCUMENT_FORM_NAME_DEBT_SCHEDULE,
      is_active: true,
    };
    const _documents = await UsersApiHelper.users_selectObject("FinancialDocument", _documentsFilter, globalState);

    const _documentID = _documents?.length ? _documents[0].id : v4();
    if (!_documents?.length) {
      const _financialDocument = {
        id: _documentID,
        year: globalState.crop_year,
        document_type_name: DOCUMENT_FORM_NAME_DEBT_SCHEDULE,
        is_active: true,
      };
      await UsersApiHelper.updateFinancialDocument(_financialDocument, globalState);
    }

    const _debtSchedulesMapped = debtSchedules?.DebtSchedule?.map((debtSchedule) => ({
      ...debtSchedule,
      document_id: _documentID,
      producer_token: globalState.producer_token,
      year: globalState.crop_year,
    }));

    const api = new ApiHelper({
      baseUrl: import.meta.env.VITE_DATANAC_USERS_API_URL_BASE,
      config: {},
      sessionManager: _sessionManager,
      // No caching:
      _instance: null,
    });

    await api.callPost(
      "DebtSchedule",
      {
        DebtSchedule: _debtSchedulesMapped,
        document_id: _documentID,
        producer_token: globalState.producer_token,
      },
      globalState
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};
